// FILE: _chat.index.tsx
// Purpose: `/` — the home page.
// Layer: Route container
//
// This route used to redirect: it created (or reused) a draft thread in
// whatever project happened to be first and replaced the URL with it, so `/`
// was never a screen anyone saw. That left a user with no visible project
// staring at a blank page, and it created a draft thread per session as a side
// effect of merely signing in. Landing is now an explicit screen.

import { createFileRoute } from "@tanstack/react-router";

import { HomeView } from "../components/HomeView";

export const Route = createFileRoute("/_chat/")({
  component: HomeView,
});
